import { Theme } from "@material-ui/core"
import FormControl from "@material-ui/core/FormControl"
import Grid from "@material-ui/core/Grid"
import InputLabel from "@material-ui/core/InputLabel"
import makeStyles from "@material-ui/core/styles/makeStyles"
import TextField from "@material-ui/core/TextField"
import React from "react"
import FieldSelect from "Components/Table/FieldSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import { useUpdate } from "./hooks"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme: Theme) => ({
    tagItem: {
        backgroundColor: "#00bcd4",
        padding: `4px 10px`,
        borderRadius: "14px",
        color: "white",
        margin: `10px ${theme.spacing(1)}px`,
        cursor: "pointer",
        boxSizing: "border-box",
        fontSize: 14,
        display: "inline-block",
        fontWeight: "bold",
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
    materialBtn: {
        display: "flex",
        justifyItems: "flex-start",
        alignItems: "center",
        marginTop: 20,
        marginLeft: -5,
    },
}))

const EatDraftUpdate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback, disabled,
        dialogData, text, isPass, isBusiness, isMine,
        handleChange, dateStr,
        external,
        handleChangeArticleType,
        editCallback,
        projectMoney, handleProjectMoneyChange,
        projectId, handleProjectIdChange,
    } = useUpdate()
    return (
        <BoardConfirmModal
            title="修改备选预约"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            editCallback={editCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{dateStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    disabled={isPass}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item>
                <FormControl disabled={isPass} className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        rowData={{
                            eat_article_type_id: external.articleTypeId,
                        }}
                        staticValueList={[]}
                        tableName="eat_article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>
                {/* <Grid item>
                    <div className={classes.materialBtn}>
                        <Button color="primary" onClick={editCallback}>编辑物料</Button>
                    </div>
                </Grid> */}

            {
                // 编辑时，用户为商务部成员且时自己的预约时，展示项目编号及金额
                isBusiness && isMine ? (
                    <>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                                error={!!(projectId && projectId.length > 50)}
                                helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                                error={!!(projectMoney && projectMoney.length > 50)}
                                helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                    </>
                ) : null
            }
        </BoardConfirmModal>
    )
}

export default EatDraftUpdate
